import { useState } from "react";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const response = await fetch("/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      alert(result.message);

      if (result.success) {
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      }
    } catch (error) {
      alert("Unable to submit form.");
      console.error(error);
    }

    setLoading(false);
  };

  return (
    <div className="max-w-1xl mx-auto">
      <h3 className="font-heading font-semibold text-2xl text-foreground mb-6">
        Enquiry
      </h3>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid gap-2 sm:gap-6 md:gap-8 max-w-full mx-auto lg:grid-cols-[minmax(0,1fr)_minmax(0,350px)] items-start">
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            required
          />
        </div>
        <div className="grid gap-2 sm:gap-6 md:gap-8 max-w-full mx-auto lg:grid-cols-[minmax(0,1fr)_minmax(0,350px)] items-start">
          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            required
          />

          <input
            type="text"
            name="subject"
            placeholder="Subject"
            value={formData.subject}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            required
          />
        </div>
        <textarea
          rows="3"
          name="message"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          className="w-full border p-2 rounded"
          required
        />

        <button
          type="submit"
          disabled={loading}
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 shadow h-10 rounded-md bg-accent text-accent-foreground hover:bg-accent/90 font-semibold px-8 text-base w-full sm:w-autol"
        >
          {loading ? "Sending..." : "Send Message"}
        </button>

      </form>
    </div>
  );
}